// Logout steps has been changed - Dev Srini 25/10/24
import { apiUrl } from '../ui-utils/apiConfig'
import { httpRequest } from '../ui-utils/api'
import snackError from './snackError'

const handleLogout = async (dispatch, navigate) => {
    const agentDetails = { email: localStorage.getItem('email') }
    let sipStatus = true
    let sipRegStsMsg
    
    // SIP Unregistration
    try {
        await window.sipUnRegister()

    } catch (error) {
        console.log('Error during SIP unregistration: ', error)
    }

    // SIP Unregistration value
    const waitForSipStatusUpdate = () => {
        return new Promise((resolve, reject) => {
            const targetNode = document.getElementById('SIP_REG_STATUS')
    
            if (!targetNode) {
                return reject('SIP_REG_STATUS element not found')
            }
    
            const observer = new MutationObserver((mutationsList, observer) => {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                        const updatedValue = targetNode.value
                        observer.disconnect()
                        resolve(updatedValue)
                    }
                }
            })

            observer.observe(targetNode, { attributes: true, attributeFilter: ['value'] })

            // Set a timeout to handle the case where the value remains 'registrationFailed' - srini -11/11/24
            const checkRegistrationFailed = setInterval(() => {
                if (targetNode.value === 'registrationFailed') {
                    clearInterval(checkRegistrationFailed);
                    observer.disconnect();
                    resolve('registrationFailed')
                }
            }, 1000)
        })
    }
    
    // Wait Unregistration to be updated
    try {
        const updatedSipStatus = await waitForSipStatusUpdate()
        sipRegStsMsg = updatedSipStatus
        console.log("SIP unRegister Status", updatedSipStatus)

        if (updatedSipStatus === 'unregistered') {
            console.log("SIP unregistered successfully.")

            dispatch({ type: 'SET_SIP_STATUS', payload: false })
            sipStatus = false
        }
        else if (updatedSipStatus === 'registrationFailed') {
            console.log("SIP Registration Failed.");  
        }
    }
    catch (error) {
        console.log('Error while waiting for SIP status update:', error)
    }

    // Handle SIP Publish based on registration status
    const sipStatusMessage = sipStatus
        ? 'There was an issue with SIP unRegistration. Proceeding to logout.'
        : 'Unregistered successfully. Proceeding to logout.'

    const errorMessage = sipStatus
        ? 'There was an issue with SIP unRegistration. Proceeding to logout.'
        : 'Unregistered successfully.'

    try {
        await window.sipPublish('closed', 'Offline', 'I am not registered')
        console.log("SIP status published successfully: 'Offline' - 'I am not registered'.")

        dispatch({ type: 'SET_AGENT_PUBLISH_STATS', payload: 'closed' })
    } catch (error) {
        console.log('Failed to publish SIP status:', error)
    }

    dispatch({ type: 'SET_SHOW_ERROR', payload: true })
    
    dispatch({ type: 'SET_ERROR', payload: errorMessage })

    console.log(`SIP status: ${sipStatusMessage}`)

    // Wait for a few seconds if there was an issue with SIP registration
    if (sipStatus) {
        dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
        await new Promise((resolve) => setTimeout(resolve, 3000))
    }

    // Clear SIP-related properties
    const propertiesToClear = ['sip_proxy', 'sip_account', 'sip_display_name', 'sip_uri', 'sip_domain',
        'sip_secret', 'socket_int', 'socket_ext', 'sip_libreary', 'socket', 'SIP']

    propertiesToClear.forEach((property) => {
        if (property in window) {
            window[property] = null;
        }
    })

    // Checking Sip UnRegister value
    if (sipRegStsMsg) {
        // Logout request
        try {
            const logoutStatus = await httpRequest({
                endPoint: `${apiUrl.logout}`,
                method: 'post',
                instance: 'instanceOne',
                requestBody: agentDetails,
            })

            if (!logoutStatus.success) {
                console.log('Logout was unsuccessful, but user signed out.', logoutStatus)
            }

        } 
        catch (error) {
            console.log('Logout error:', error)  
        }
        finally{
            dispatch({ type: 'USER_SIGN_IN', payload: false })
            dispatch({ type: 'SET_TOKEN_VAL', payload: '' })
             
            localStorage.clear()
            navigate('/')
        }
    }
}


export default handleLogout